import useUser from './useUser';

export const useScopedSiteFilter = () => {
  const { canAccessAllSites, siteId } = useUser();

  const applySiteScope = (params = {}, selectedSiteId = '') => {
    const scopedParams = { ...params };
    if (canAccessAllSites) {
      if (selectedSiteId) scopedParams.site_id = selectedSiteId;
      return scopedParams;
    }

    if (siteId) scopedParams.site_id = siteId;
    return scopedParams;
  };

  return {
    canAccessAllSites,
    fixedSiteId: canAccessAllSites ? null : siteId,
    applySiteScope,
  };
};

export default useScopedSiteFilter;

